import { Teaser } from './teaser';
import { Vehicle } from './vehicle';

export class VerifyVehicle {
    public vehicle: Vehicle;
    public teaser: Teaser;
    public IsVerified: boolean;
}
